function getBrowserLocation(): Location | null {
  return typeof window !== 'undefined' ? window.location : null
}

function isLocalHostname(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '[::1]'
}

function isIpv4Address(hostname: string): boolean {
  return /^(\d{1,3}\.){3}\d{1,3}$/.test(hostname)
}

function isIpv6Address(hostname: string): boolean {
  return hostname.includes(':') && /^[0-9a-f:]+$/i.test(hostname)
}

function isIpAddress(hostname: string): boolean {
  return isIpv4Address(hostname) || isIpv6Address(hostname)
}

function stripTrailingSlash(value: string): string {
  return value.replace(/\/$/, '')
}

function normalizeRelativeUrl(value: string, fallbackPath: string): string {
  const normalized = value.trim().replace(/^\/+/, '').replace(/\/$/, '')
  return normalized ? `/${normalized}` : fallbackPath
}

function shouldUseCurrentOrigin(target: URL, current: Location): boolean {
  if (isLocalHostname(current.hostname)) return false
  if (isIpAddress(target.hostname)) return true
  if (current.protocol === 'https:' && target.protocol !== 'https:') return true
  return false
}

function rewriteToCurrentOrigin(target: URL, current: Location): string {
  return `${current.origin}${stripTrailingSlash(target.pathname)}${target.search}${target.hash}`
}

export function resolveApiBaseUrl(value?: string): string {
  const trimmed = value?.trim()
  if (!trimmed) return '/api'

  if (!/^https?:\/\//i.test(trimmed)) {
    return normalizeRelativeUrl(trimmed, '/api')
  }

  const target = new URL(trimmed)
  const current = getBrowserLocation()
  if (current && shouldUseCurrentOrigin(target, current)) {
    return rewriteToCurrentOrigin(target, current)
  }

  return stripTrailingSlash(trimmed)
}

export function resolveSocketUrl(value?: string): string {
  const current = getBrowserLocation()
  const trimmed = value?.trim()

  if (!trimmed) {
    return current ? current.origin : 'http://localhost:3001'
  }

  if (!/^https?:\/\//i.test(trimmed)) {
    return current ? current.origin : trimmed
  }

  const target = new URL(trimmed)
  if (current && shouldUseCurrentOrigin(target, current)) {
    return current.origin
  }

  return stripTrailingSlash(trimmed)
}
